/**
 * Utility to get customer filter params for API calls
 * Ensures consistent customer filtering across all admin components
 */

interface CustomerParamsOptions {
  isLoginAsCustomer: boolean;
  memberCustomerID?: number;
  customerFilterIsFiltered: boolean;
  customerFilterCustomerId?: string | null;
  memberType?: string;
}

/**
 * Get customer params for API calls based on current context
 * Priority: Login as customer > Customer filter > Default
 */
export const getCustomerParams = (options: CustomerParamsOptions): Record<string, string> => {
  const {
    isLoginAsCustomer,
    memberCustomerID,
    customerFilterIsFiltered,
    customerFilterCustomerId,
    memberType
  } = options;

  const params: Record<string, string> = {};
  
  // First priority: Login as customer mode
  if (isLoginAsCustomer && memberCustomerID) {
    params.customerId = String(memberCustomerID);
  } 
  // Second priority: Customer filter for admins
  else if (customerFilterIsFiltered && (memberType === 'master_admin' || memberType === 'reseller_admin') && customerFilterCustomerId) {
    params.customerId = String(customerFilterCustomerId);
  }
  
  return params;
};

/**
 * Append customer params to an existing URL
 */
export const appendCustomerParams = (url: string, params: Record<string, string>): string => {
  const queryString = new URLSearchParams(params).toString();
  if (!queryString) return url;
  
  // Check if URL already has query params
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${queryString}`;
};

/**
 * Create URL with customer params
 */
export const createUrlWithCustomerParams = (baseUrl: string, params: Record<string, string>): string => {
  const queryString = new URLSearchParams(params).toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};